import { createFileRoute, redirect, isRedirect } from '@tanstack/react-router'
import { hasAccessToken, getAccessToken } from '@/lib/token-storage'
import { getUserProfile } from '@/api/workspace/profile.actions'
import { userRequiresPhoneVerification } from '@/lib/phone-verification-gate'
import LoginPage from '@/pages/auth/login'
import {
  getMainAppHandoffHref,
  getSuporteAppBaseUrl,
  getSuporteAppHandoffHref,
  getAdmindeskAppBaseUrl,
  getAdmindeskAppHandoffHref,
} from '@/lib/post-login-redirect'
import { syncImobdeskEntryAppFromSearch } from '@/lib/imobdesk-entry-app'
import { loginRedirectSearchSchema } from '@/lib/login-redirect-search'
import { redirectIfLoginSignedOutQuery } from '@/lib/handle-signed-out-query'

export const Route = createFileRoute('/')({
  validateSearch: loginRedirectSearchSchema,
  beforeLoad: async ({ search }) => {
    syncImobdeskEntryAppFromSearch(search)
    await redirectIfLoginSignedOutQuery('/', search)
    if (!hasAccessToken()) {
      return
    }
    const at = getAccessToken()
    if (!at) {
      return
    }

    try {
      const profile = await getUserProfile()
      if (
        userRequiresPhoneVerification(
          profile.data.celular,
          profile.data.celularConfirmado,
        )
      ) {
        throw redirect({
          to: '/completar-celular',
          search: {
            next: search.next,
            return_app: search.return_app,
          },
        })
      }
    } catch (error) {
      if (isRedirect(error)) {
        throw error
      }
      return
    }

    if (search.return_app === 'suporte') {
      const sup = getSuporteAppBaseUrl()
      if (!sup) {
        return
      }
      throw redirect({
        href: getSuporteAppHandoffHref(
          { accessToken: at },
          { next: search.next },
        ),
      })
    }
    if (search.return_app === 'admindesk') {
      const ad = getAdmindeskAppBaseUrl()
      if (!ad) {
        return
      }
      throw redirect({
        href: getAdmindeskAppHandoffHref(
          { accessToken: at },
          { next: search.next },
        ),
      })
    }
    const base = import.meta.env.VITE_MAIN_APP_URL as string | undefined
    if (!base?.trim()) {
      return
    }
    throw redirect({
      href: getMainAppHandoffHref(
        {
          accessToken: at,
        },
        { next: search.next },
      ),
    })
  },
  component: LoginPage,
})
